import React from 'react';
import { CircularProgress, Grid, Button } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';

const LoadingButton = (
  {
    loading,
    label,
    onClick,
    disabled = false,
    style = {},
    color = undefined,
    variant = undefined,
  },
) => {
  return (
    <Grid container style={ { maxWidth: '100px', ...style } }>
      <Grid item xs={ 12 } sm={ 4 }>
        <Button
          onClick={ onClick }
          disabled={ disabled || loading }
          color={ color }
          variant={ variant }
        >
          { loading
          && (
            <CircularProgress
              size={ 24 }
              color='secondary'
              style={ { margin: '0 10px' } }
            />
          ) }
          <div>
            { label }
          </div>
        </Button>
      </Grid>
    </Grid>
  );
};

export const LoadingButtonNoGrid = (
  {
    loading,
    label,
    onClick = undefined,
    disabled = false,
    style = {},
    color = undefined,
    variant = undefined,
    buttonStyle = {},
    labelColor = undefined,
    progressColor = undefined,
    deleteIcon = false,
    download = undefined,
    href = undefined,
    type = undefined,
  },
) => {
  return (
    <span style={ { ...style } }>
      <Button
        onClick={ onClick }
        disabled={ disabled || loading }
        color={ color }
        variant={ variant }
        style={ { ...buttonStyle, color: labelColor } }
        startIcon={ true === deleteIcon && !loading ? <Delete /> : '' }
        download={ download }
        href={ href }
        type={ type }
      >
        { loading
          && (
            <CircularProgress
              size={ 24 }
              color={ progressColor ? undefined : 'secondary' }
              style={ { margin: '0 10px', color: progressColor } }
            />
          ) }
        <div>
          { label }
        </div>
      </Button>
    </span>
  );
};

export default LoadingButton;
